import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IndoorEliteBootstrapComponent } from './indoor-elite-bootstrap/indoor-elite-bootstrap.component';

const routes: Routes = [
    {path: '', component: IndoorEliteBootstrapComponent, pathMatch: 'full'}

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IndoorWorldSeriesEliteRankingRoutingModule { }
